import { makeStyles } from '@mui/styles';
import { CustomTheme } from 'types/theme';

export const useStyles = makeStyles((theme: CustomTheme) => ({
  container: {
    background: '#FFFFFF',
    padding: 18,
    maxWidth: 452,
    margin: '0 auto',
    minHeight: 'calc(100% - 68px)',
    display: 'flex',
    flexDirection: 'column'
  },
  header: {
    padding: '0 16px'
  },
  title: {
    textAlign: 'center',
    '&.MuiTypography-root': {
      fontSize: 34,
      lineHeight: '37px',
      letterSpacing: 0.25,
    }
  },
  subtitle: {
    textAlign: 'center',
    '&.MuiTypography-root': {
      color: theme.palette.text.secondary,
      fontSize: 16,
      lineHeight: '24px',
      letterSpacing: 0.15000000596046448,
      marginTop: 8,
    }
  },
}));
